import { render, staticRenderFns } from "./ECN2023.vue?vue&type=template&id=d282728c&scoped=true"
import script from "./ECN2023.vue?vue&type=script&lang=js"
export * from "./ECN2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d282728c",
  null
  
)

export default component.exports